import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 60000 });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && (url.startsWith("/dealer") || url === "/auth/me")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("hcs-logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "We couldn't connect. Please check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  if (d && typeof d.message === "string") return d.message;
  return fallback;
}

export const fieldErrors = (e) => e?.response?.data?.detail?.fields || {};
export const gbp = (n) => (n == null ? "" : `£${Math.round(n).toLocaleString("en-GB")}`);
export const miles = (n) => `${Number(n).toLocaleString("en-GB")} miles`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
export const photoUrl = (id, size = "full") => `${API}/dealer/photos/${id}?size=${size}`;
export const telHref = (p) => `tel:${(p || "").replace(/[^\d+]/g, "")}`;
